import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	underOneMinuteText: {
		id: 'autodev.common.time-elapsed.under-one-minute-text',
		defaultMessage: 'Just now',
		description: 'A text to indicate the last data fetch time was under a minute.',
	},
	overOneMinuteText: {
		id: 'autodev.common.time-elapsed.over-one-minute-text',
		defaultMessage: '{date}',
		description: 'A text to indicate the last data fetch time was over a minute.',
	},
});
